import React from 'react';

const Logo = ({ fill = 'white' }) => (
  <svg viewBox="0 0 72.8 56.6" height="35px" fill={fill}>
    <path
      d="M17.3,10.2c0,0-2.9,0.3-3.1,4.5v26.5c0,0-6.7-2.3-9.4-11.4V11.7c0,0,1-8.3,7.8-8.3h7.8v4.5
		C20.4,7.9,20.2,9.6,17.3,10.2z M4.8,42.8v-5.3c0,0,3.6,7.8,12.5,8.3c0,0,3.1,0.3,3.1,3v4.5h-7C13.4,53.4,4.9,52.9,4.8,42.8z
		 M38.9,45.2c0-1.1-0.9-1.9-2-1.9c-1.1,0-2,0.9-2,1.9c0,1.1,0.9,1.9,2,1.9C38,47.1,38.9,46.3,38.9,45.2z M46.2,13.3
		c-6.2,0-12.5,0-18.7,0c0,9.3,0,18.7,0,28c6.2,0,12.5,0,18.7,0C46.2,32,46.2,22.6,46.2,13.3z M24.4,46.6V10.2h25v36.4
		c0,0-6.5,2.3-12.8,2.3C30.5,48.8,24.4,46.6,24.4,46.6z M59.5,41.3V14.8c-0.2-4.2-3.1-4.5-3.1-4.5c-2.8-0.6-3.1-2.3-3.1-2.3V3.4H61
		c6.8,0.1,7.8,8.3,7.8,8.3v18.2C66.2,39,59.5,41.3,59.5,41.3z M60.2,53.4h-7v-4.5c0.1-2.8,3.1-3,3.1-3c8.8-0.5,12.5-8.3,12.5-8.3
		v5.3C68.7,52.9,60.2,53.4,60.2,53.4z"
    />
  </svg>
);

export default Logo;
